export default __webpack_public_path__ + "static/media/CNo.62-0.0596a406.jpg";